/* ═══════════════════════════════════════════════════
   TrackLab v2 — Shared State
   ═══════════════════════════════════════════════════ */

window.TL = window.TL || {};

// ── Score thresholds (win probability %) ──
// Source of truth is racing/score_bands.py, server-rendered into
// <script id="tlScoreBands"> (templates/base.html). The literal below is only a
// fallback for standalone/test use; parity is enforced by test_ux_s7/test_score_bands.
TL.SCORE_THRESHOLDS = [
  { min: 40, tier: 'top',   label: 'Very strong chance' },
  { min: 20, tier: 'great', label: 'Strong chance' },
  { min: 12, tier: 'good',  label: 'Solid chance' },
  { min:  6, tier: 'mid',   label: 'Could surprise' },
  { min:  0, tier: 'low',   label: 'Long shot' },
];
(function () {
  var el = typeof document !== 'undefined' && document.getElementById('tlScoreBands');
  if (!el) return;
  try {
    var bands = JSON.parse(el.textContent);
    var ok = Array.isArray(bands) && bands.length && bands.every(function (b) {
      return b && typeof b.min === 'number' && typeof b.tier === 'string';
    });
    if (ok) {
      TL.SCORE_THRESHOLDS = bands.slice().sort(function (a, b) { return b.min - a.min; });
    }
  } catch (e) { /* keep fallback */ }
})();

// Bands on the integer the user sees (TL.scorePct rounds), so 19.5 -> "20" -> great.
TL.scoreTier = function (score) {
  var n = Math.round(Number(score) || 0);
  for (var i = 0; i < TL.SCORE_THRESHOLDS.length; i++) {
    if (n >= TL.SCORE_THRESHOLDS[i].min) return TL.SCORE_THRESHOLDS[i];
  }
  return TL.SCORE_THRESHOLDS[TL.SCORE_THRESHOLDS.length - 1];
};

// "s-top" / "s-great" / "s-good" / "s-mid" / "s-low"
TL.scoreTierClass = function (score) {
  return 's-' + TL.scoreTier(score).tier;
};

// Scores are plain numbers, no % sign (12 Oct 2026); a race's scores add up
// to 100. Mirrors score_bands.score_text / score_chance: "28", "28 Strong chance".
TL.scorePct = function (score) {
  if (score === null || score === undefined || score === '') return '';
  var n = Math.round(Number(score));
  return isNaN(n) ? '' : String(n);
};

TL.scoreChance = function (score) {
  var p = TL.scorePct(score);
  return p ? p + ' ' + TL.scoreTier(score).label : '';
};

// ── Value gate (F4) ──
// Mirrors racing/services.py implied_pct / gate_value_signal / value_tip:
// a value label only shows when the displayed score (integer %) is strictly
// greater than the implied % chance of the displayed fractional odds.
TL.impliedPct = function (fractional) {
  if (!fractional || typeof fractional !== 'string') return null;
  var parts = fractional.trim().split('/');
  if (parts.length !== 2 || !/^-?\d+$/.test(parts[0].trim()) || !/^-?\d+$/.test(parts[1].trim())) return null;
  var num = parseInt(parts[0], 10);
  var den = parseInt(parts[1], 10);
  if (den <= 0 || num < 0) return null;
  return den / (num + den) * 100;
};

TL.gateValueSignal = function (score, fractional, rawSignal) {
  if (rawSignal !== 'VALUE' && rawSignal !== 'SUPER_VALUE') return 'NEUTRAL';
  if (typeof score !== 'number' || isNaN(score)) return 'NEUTRAL';
  var implied = TL.impliedPct(fractional);
  if (implied === null || !(score > implied)) return 'NEUTRAL';
  return rawSignal;
};

TL.valueTip = function (score, fractional) {
  if (TL.gateValueSignal(score, fractional, 'VALUE') !== 'VALUE') return '';
  var pct = TL.impliedPct(fractional).toFixed(1).replace(/\.0$/, '');
  return 'Value: our estimated chance (' + Math.trunc(score) + '%) is higher than the ' +
    "bookmaker's odds suggest (" + pct + '%).';
};

// ── Value box (race page) ──
// Mirrors racing/services.py return_for_pound / value_box (identical output).
TL.returnForPound = function (fractional) {
  if (TL.impliedPct(fractional) === null) return null;
  var parts = fractional.trim().split('/');
  var num = parseInt(parts[0], 10);
  var den = parseInt(parts[1], 10);
  var cents = Math.floor(((num + den) * 200 + den) / (2 * den));
  var pence = cents % 100;
  return '£' + Math.floor(cents / 100) + '.' + (pence < 10 ? '0' : '') + pence;
};

TL.valueBox = function (score, fractional, rawSignal) {
  var isValue = TL.gateValueSignal(score, fractional, rawSignal) !== 'NEUTRAL';
  var heading = isValue ? 'Underrated horse' : 'Fair price';
  var body = isValue
    ? "We think it's more likely to win than the odds suggest, so if it wins, it pays more than it should."
    : "TrackLab and the bookies agree on this horse's chances.";
  var ret = TL.returnForPound(fractional);
  var returnText = ret ? 'Bet £1, and if it wins you get ' + ret + ' back.' : '';
  if (returnText) body = body + ' ' + returnText;
  return { heading: heading, body: body, is_value: isValue, return_text: returnText };
};

// Toggle a server-rendered bookmaker dropdown (used by featured cards and event pick cards).
// chevBtn is the button inside .fr-bookie-split; the dropdown is its next sibling.
TL.toggleBookieDrop = function (chevBtn) {
  var split = chevBtn.closest('.fr-bookie-split');
  var drop = split && split.nextElementSibling;
  if (!drop || !drop.classList.contains('fr-bookie-dropdown')) return;
  var open = drop.classList.toggle('open');
  chevBtn.classList.toggle('open', open);
};

// Glossary lookup. Reads the server-rendered <script id="tlGlossary"> once.
// TL.gloss(key) -> { label, short, tip } or null; TL.gloss.all() -> full dict.
TL.gloss = function (key) {
  var all = TL.gloss.all();
  return all && Object.prototype.hasOwnProperty.call(all, key) ? all[key] : null;
};
TL.gloss._cache = null;
TL.gloss.all = function () {
  if (TL.gloss._cache) return TL.gloss._cache;
  var el = document.getElementById('tlGlossary');
  if (!el) return {};
  try {
    TL.gloss._cache = JSON.parse(el.textContent) || {};
  } catch (e) {
    return {};
  }
  return TL.gloss._cache;
};

// Make `el` a glossary tooltip trigger for `key` (same attrs as the {% gloss %} tag).
// Used when JS changes a status badge after a poll, so the tip follows the text.
// Unknown key: strips the tip so a stale one is never left behind.
TL.gloss.tag = function (el, key) {
  if (!el) return el;
  var entry = TL.gloss(key);
  if (!entry) {
    el.classList.remove('tl-tip', 'tl-gloss');
    ['data-gloss', 'data-tip-title', 'data-tip-body', 'data-tip-href'].forEach(function (a) { el.removeAttribute(a); });
    return el;
  }
  el.classList.add('tl-tip', 'tl-gloss');
  el.setAttribute('data-gloss', key);
  el.setAttribute('data-tip-title', entry.label);
  el.setAttribute('data-tip-body', entry.tip);
  if (entry.link) el.setAttribute('data-tip-href', entry.link);
  else el.removeAttribute('data-tip-href');
  return el;
};

TL.state = {
  activeRaceId: null,
  activePollers: {},    // raceId → { eventId, timer, failures, offDtLocked }
  betNum: 0,
  betDen: 1,
  betAmt: 1,
  betType: 'win',       // 'win' | 'ew'
  betScore: null,
  ewPlaces: null,
  ewFraction: null,
};
